//To be deleted as part of LMNUK_1234 clean up...
(() => {
  angular.module('pims')
    .directive('setCaretPosition', function() {
      return {
        restrict: 'A',
        scope: {
          args: '=setCaretPosition'
        },
        link: function(scope, element) {
          validate()
          function setCaretPosition(elem, pos, autoJump) {
            if (autoJump) {
              if (elem.setSelectionRange) {
                elem.focus();
                elem.setSelectionRange(pos, pos);
              } else if (elem.createTextRange) {
                const range = elem.createTextRange();
                range.collapse(true);
                range.moveEnd('character', pos);
                range.moveStart('character', pos);
                range.select();
              }
            }
          }

          // Validations
          function validate() {
            const expectedArgs = ['position', 'autoJump'];
            // Check if the provided attribute matches the expected structure
            if (!angular.isObject(scope.args) || !expectedArgs.every(arg => Object.keys(scope.args).includes(arg))) {
              console.error('setCaretPosition directive requires an object with "position" and "autoJump" properties.');
              return false;
            }
            // Check for unexpected attributes
            const unexpectedAttrs = Object.keys(scope.args).filter(attribute => !expectedArgs.includes(attribute));
            if (unexpectedAttrs.length > 0) {
              unexpectedAttrs.forEach(attr => console.error(`Unexpected attribute "${attr}" provided to setCaretPosition directive.`));
              return false;
            }
            return true;
          }

          function handleClick() {
            if (!validate()) {
              return
            }
            setCaretPosition(element[0], scope.args.position, scope.args.autoJump);
          }

          element.on('click', handleClick);

          scope.$on('$destroy', function() {
            element.off('click', handleClick);
          });
        }
      };
  });
})();
